import React from 'react'

const baseUrl = 'https://voicearchive-branding.s3.eu-central-1.amazonaws.com'

const Logo = (props) => {
  const alt = props.alt || 'VoiceArchive';
  let src = '';

  switch(props.colour) {
    case 'black':
      src = `${baseUrl}/small-curve-black.svg`
      break;
    case 'white':
      src = `${baseUrl}/small-curve-white.svg`
      break;
    default:
    case 'blue':
      src = `${baseUrl}/small-curve-blue.svg`
      break;
  }

  return (
    <img alt={alt} src={src} />
  );
};

export default Logo;